import { Box, Grid, Text } from '@chakra-ui/react'
import { motion } from 'framer-motion'
import { LuImages as Images } from 'react-icons/lu'
import SectionCard from './SectionCard'
import AuthImage from '../../../../components/media/AuthImage'
import { shipmentsService } from '../../../../api/services/shipments.service'
import { themeColors } from '../../../../theme'
import type { PhotoWithTime } from '../../../../lib/trackAnalytics'

const MotionBox = motion.create(Box)
const colors = themeColors

interface Props {
  shipmentId: string
  photos: PhotoWithTime[]
  onOpen: (index: number) => void
  delay?: number
}

export default function PhotoGallery({ shipmentId, photos, onOpen, delay = 0 }: Props) {
  return (
    <SectionCard
      title="Fotos del traslado"
      subtitle={`${photos.length} foto${photos.length !== 1 ? 's' : ''}`}
      icon={Images}
      accent="#d49a2a"
      delay={delay}
    >
      <Grid templateColumns="repeat(auto-fill, minmax(130px, 1fr))" gap={3}>
        {photos.map((p, i) => (
          <MotionBox
            key={p.photo.id}
            as="button"
            position="relative"
            borderRadius="xl"
            overflow="hidden"
            border="1px solid"
            borderColor={colors.border}
            cursor="pointer"
            aspectRatio={1}
            _hover={{ borderColor: '#1A7A4C' }}
            transitionProperty="border-color"
            transitionDuration="0.15s"
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => onOpen(i)}
          >
            <AuthImage
              src={shipmentsService.getPhotoUrl(shipmentId, p.photo.id)}
              alt={p.photo.photoType}
              minHeight="130px"
              style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
            />
            <Box
              position="absolute"
              bottom={0}
              left={0}
              right={0}
              px={2}
              py={1.5}
              background="linear-gradient(to top, rgba(0,0,0,0.7), transparent)"
            >
              <Text fontSize="11px" fontWeight="600" color="white" textAlign="left" truncate>
                {p.photo.photoType}
              </Text>
            </Box>
          </MotionBox>
        ))}
      </Grid>
    </SectionCard>
  )
}
